import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ProfileService, UsersService } from 'apis/identity';
import { MyUsersService } from '../services/my-users.service';
import { UpdateUserDto } from '../../../apis/identity/model/updateUserDto';

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.page.html',
  styleUrls: ['./user-edit.page.scss'],
})
export class UserEditPage implements OnInit {

  form: FormGroup;
  errorMessage = '';
  errorState = '';

  titleText: string;
  btntext: string;

  countryCode: string; 
  phoneCode = ''; 
  phone: string; 

  passwordType = 'password';
  passwordIcon = 'eye-off';
  changePass = false;

  constructor(private router: Router,
              private usersService: UsersService,
              private profileService: ProfileService,
              public myUsersService: MyUsersService) { }

  ngOnInit() {
  }

  ionViewWillEnter() {

    // this.countryCode = '+55';
    this.btntext    = 'Salvar';
    this.titleText  = 'Editar Usuario'// 'Editar: ' + this.myUsersService.userToEdit.username;

    // phoneCode TASK
    /*if (this.myUsersService.userToEdit.phonenumber.indexOf(':') !== -1) {
      const aux = this.myUsersService.userToEdit.phonenumber.split(':');
      this.phoneCode = aux[1];
      this.phone = aux[2];
    } else {
      this.phone = this.myUsersService.userToEdit.phonenumber;
    }*/

    // FormGroup
    this.form = new FormGroup({
      userName:   new FormControl(this.myUsersService.userToEdit.username, [Validators.required]),
      fullName:   new FormControl(this.myUsersService.userToEdit.fullname, [Validators.required]),
      email:      new FormControl(this.myUsersService.userToEdit.email, [Validators.required]),
      password:   new FormControl('', null),
      city:       new FormControl(this.myUsersService.userToEdit.city, [Validators.required]),
      // phoneCode TASK
      // tslint:disable-next-line: max-line-length
      // phoneCode:  new FormControl(this.phoneCode, [Validators.required, Validators.max(99), Validators.min(10)]),
      // phoneCode TASK
      // phone:      new FormControl(this.myUsersService.userToEdit.phonenumber, [Validators.required]),
    });

    this.form.controls['userName'].valueChanges.subscribe(data => {
      this.errorMessage = '';
      this.errorState = '';
    });

    this.form.controls['email'].valueChanges.subscribe(data => {
      this.errorMessage = '';
      this.errorState = '';
    });

    // phoneCode TASK
    /*this.form.controls['phoneCode'].valueChanges.subscribe(data => {
      if (this.errorState === 'phoneCode') {
        this.errorMessage = '';
        this.errorState = '';
      }
      if (data < 10) {
        this.errorState = 'phoneCode';
        this.errorMessage = 'O valor deve ser maior que 9';
      } else if (data > 99) {
        this.errorState = 'phoneCode';
        this.errorMessage = 'O valor deve ser menor que 100';
      }
    });*/

  }

  hideShowPassword() {

  }

  changePassState(){
    this.changePass = !this.changePass;
  }

  sendApi() {
    
    // const user: UpdateUserDto = {} as UpdateUserDto;
    this.myUsersService.userToEdit.city = this.form.controls['city'].value;
    this.myUsersService.userToEdit.username = this.form.controls['userName'].value;
    this.myUsersService.userToEdit.fullname = this.form.controls['fullName'].value;
    // this.myUsersService.userToEdit.phone = this.form.controls['phone'].value;
    this.myUsersService.userToEdit.email = this.form.controls['email'].value.toString();
    
    // user.password = this.form.controls['password'].value;
    
    // varios llamados ver
    // http://ngserve.blogspot.com/2017/08/multiples-peticiones-http-con-rxjs.html

    this.profileService.usersIdProfilePost(this.myUsersService.userIdToEdit.toString(), this.myUsersService.userToEdit).pipe().subscribe(data => {
      alert('se guardo correctamente');
    }, error => {
      alert('error');
    })
  }

  customFormValid() {

  }
}
